import React from 'react';

const Hawaii = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Hawaii Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Standard disclosure form provided by the Hawaii Association of
          Realtors.
        </li>
        <li>
          Disclosure Statement: Sellers must provide within 10 days of
          acceptance of an offer.{' '}
        </li>
        <li>Termite Inspection: Often required due to local conditions.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Hawaii-Sellers-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – After the agreement is executed, the seller must complete a property
          disclosure in good faith within 10 calendar days.
        </li>
      </ol>
    </div>
  );
};

export default Hawaii;
